import { render, staticRenderFns } from "./LanguageChoiceContainer.vue?vue&type=template&id=3cd1e610&scoped=true&"
import script from "./LanguageChoiceContainer.vue?vue&type=script&lang=js&"
export * from "./LanguageChoiceContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd1e610",
  null
  
)

export default component.exports